module.exports = __webpack_public_path__ + "static/media/edly-login-lamp.f9823b5a.svg";